import { computedFrom } from "aurelia-binding";


export enum MepScenarioPlanningTabsEnum {
    PortTraffic = 1,
    ShorePower = 2,
    Vessels = 3
}

export interface MepScenarioPlanningRequest {
}

export interface MepShorePowerActualEmissionsRequest extends MepScenarioPlanningRequest {
    emissionTypeIds: number[];
    portId: number;
    baselineYear: number;
}

export interface MepPortTrafficActualEmissionsRequest extends MepScenarioPlanningRequest {
    emissionTypeIds: number[];
    portId: number;
    baselineYear: number;
}

export interface MepPortTrafficActualEmissionsResponse {
    items: MepPortTrafficActualEmissionsItem[];
}

export interface MepPortTrafficActualEmissionsItem {
    portVesselTypeId: number;
    vesselGroupType : string;
    vesselCallsTugboatJobs: number;
    averageTimeInPortInDays: number;
    averageEmissionsInKgPerHour: number;
}

export interface MepShorePowerActualEmissionsResponse {
    items: MepShorePowerActualEmissionsItem[];
    totalEmissionsQtyTonnes: number
}

export interface MepShorePowerActualEmissionsItem {
    pointOfInterestId: number;
    pointOfInterestName: string;
    emissionAlongsideTonnes: number;
    emssionAlongsidePercentage : number;
}

export class MepShorePowerForecastEmissionsItem {
    constructor(private actualItem: MepShorePowerActualEmissionsItem) {
        this.pointOfInterestId = actualItem.pointOfInterestId;
    }

    pointOfInterestId: number;
    shorePowerUsagePercentage: number = 0;
    
    get emissionAlongsideTonnes(): number {
        return (1 - this.shorePowerUsagePercentage / 100) * this.actualItem.emissionAlongsideTonnes;
    }
}

export class MepPortTrafficForecastEmissionsItem {
    constructor(private actualItem: MepPortTrafficActualEmissionsItem) {
        this.portVesselTypeId = actualItem.portVesselTypeId;
        this.vesselCallsTugboatJobs = actualItem.vesselCallsTugboatJobs;
        this.averageTimeInPortInDays = actualItem.averageTimeInPortInDays;
    }

    portVesselTypeId: number;
    vesselGroupType : string;
    _vesselCallsTugboatJobs: number = 0;
    _averageTimeInPortInDays: number = 0;    

    @computedFrom('_vesselCallsTugboatJobs')
    get vesselCallsTugboatJobs (): number {
        return this._vesselCallsTugboatJobs;
    }

    set vesselCallsTugboatJobs (value: number) {
        this._vesselCallsTugboatJobs = Number(value);
    }

    @computedFrom('_averageTimeInPortInDays')
    get averageTimeInPortInDays (): number {
        return this._averageTimeInPortInDays;
    }

    set averageTimeInPortInDays (value: number) {
        this._averageTimeInPortInDays = Number(value);
    }

    @computedFrom('vesselCallsTugboatJobs', 'averageTimeInPortInDays', 'actualItem.vesselCallsTugboatJobs', 'actualItem.averageTimeInPortInDays')
    get averageEmissionsInKgPerHour(): number {
        if (this.actualItem.vesselCallsTugboatJobs == 0 || this.actualItem.averageTimeInPortInDays == 0) {
            return 0;
        }
        
        return this.actualItem.averageEmissionsInKgPerHour * this.vesselCallsTugboatJobs * this.averageTimeInPortInDays / (this.actualItem.vesselCallsTugboatJobs * this.actualItem.averageTimeInPortInDays);
    }
}